// extracted by mini-css-extract-plugin
module.exports = {"flex":"Cards_flex__251Kd","flexItem":"Cards_flexItem__32p9L"};